import {map} from 'rxjs/operators';
import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchSuggestions = (institutionId: string, billPayerId: string) => {
    return RESTClient.getAuthenticatedObservable(
        `v2/invoicing/${institutionId}/billPayers/${billPayerId}/suggestRecipients`,
    ).pipe(
        map(response => {
            if (!response || !response.suggested) {
                return List();
            }

            return List(response.suggested);
        }),
    );
};
